import { ArrowDown01Icon, ArrowUp01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useMemo, useState } from "react";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { Accordion, AccordionDetails, AccordionSummary, Button, Stack } from "@mui/material";
import { useNode } from "@craftjs/core";
import { useFetchFaqsQuery } from "@/features/organizations/api/faqApi";
import FaqsBlockSettings from "../settings/FaqSettings/FaqsBlockSettings";
import { useAppSelector } from "@/hooks";
import parse from "html-react-parser";

interface FaqsProps {
  limit: number | "all";
  enableLimit: boolean;
}

const FaqsBlock = (props: FaqsProps) => {
  const [expanded, setExpanded] = useState<string | false>(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const activeOrganization = useAppSelector((store) => store.ui.activeOrganization);
  const { data } = useFetchFaqsQuery(activeOrganization || skipToken);

  const { limit = 5, enableLimit } = props;

  const limitData = useMemo(() => {
    if (isExpanded) {
      return data;
    }

    return limit === "all" ? data : data?.slice(0, limit);
  }, [data, isExpanded, limit]);

  const handleChange = (id: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? id : false);
  };

  const {
    connectors: { connect, drag },
  } = useNode();

  return (
    <div ref={(ref: any) => connect(drag(ref))} className={"faqs"}>
      <Stack spacing={2}>
        <div>
          {limitData?.map((d, index) => (
            <Accordion key={`${d.id}-${index}`} expanded={expanded === d.id} onChange={handleChange(d.id)} elevation={0}>
              <AccordionSummary expandIcon={<HugeiconsIcon icon={ArrowDown01Icon} />} id={`accordion${d.id}`}>
                <h5>{d.question}</h5>
              </AccordionSummary>
              <AccordionDetails>{d.answer ? parse(d.answer) : <p>{d.answer}</p>}</AccordionDetails>
            </Accordion>
          ))}
        </div>
        <Stack alignItems={"center"}>
          {enableLimit ? (
            <Button variant="outlined" color="primary" onClick={() => setIsExpanded((prev) => !prev)} endIcon={isExpanded ? <HugeiconsIcon icon={ArrowUp01Icon} /> : <HugeiconsIcon icon={ArrowDown01Icon} />}>
              {isExpanded ? "Ver Menos" : "Ver Más "}
            </Button>
          ) : null}
        </Stack>
      </Stack>
    </div>
  );
};

FaqsBlock.craft = {
  displayName: "Preguntas Frecuentes",
  related: {
    settings: FaqsBlockSettings,
  },
};

export default FaqsBlock;
